import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getMarketplaceEntities } from '../../../../ducks/marketplaceData.duck';
import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded';
import css from './SectionCreator.module.css';

const SectionCreatorComponent = ({ listing, listings, history, currentAuthor }) => {
  if (!listings.length) return <></>;
  const avatarImage = listing?.author?.profileImage?.attributes?.variants?.['square-small2x']?.url;
  const authorHandle = listing?.author?.attributes?.profile?.displayName;
  const bio = listing?.author?.attributes?.profile?.bio;
  const authorListingsData = listings.map((l) => ({
    to: `/l/${l?.attributes?.title?.replaceAll(' ', '-')}/${l.id.uuid}`,
    image: l?.images[0]?.attributes?.variants?.['listing-card-2x']?.url,
  }));

  return (
    <div className={css.wrapper}>
      <div className={css.contentWrapper}>
        <p className={css.title}>Meet the creator</p>
        <div className={css.avatarBox}>
          {avatarImage && (
            <img src={avatarImage} alt={'profile image'} className={css.avatarImage} />
          )}
          <div className={css.authorDetails}>
            <div className={css.starIconWrapper}>
              <StarRateRoundedIcon className={css.starIcon} />
            </div>
            <div className={css.handleWrapper}>
              <p className={css.topRated}>Top Rated</p>
              <p className={css.handle}>@{authorHandle}</p>
            </div>
          </div>
        </div>
        {bio && <p className={css.bio}>{bio}</p>}
        <div className={css.scansWrapper}>
          <p className={css.smallPrint}>Recent scans from this creator…</p>
          <div className={css.listings}>
            {authorListingsData.slice(0, 3).map((l) => (
              <div className={css.listingCard} onClick={() => history.push(l.to)}>
                <img src={l.image} className={css.listingCardImage} />
              </div>
            ))}
          </div>

          <button
            type="button"
            onClick={() => history.push(`/u/${currentAuthor.id.uuid}`)}
            className={css.cta}
          >
            <span>View Profile</span>
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { authorListingRefs = [], id: currentListingId } = state.ListingPage || {};
  const allAuthorListings = getMarketplaceEntities(state, authorListingRefs);

  // Filter out the current listing from the author's listings
  const listings = currentListingId
    ? allAuthorListings.filter((listing) => listing?.id?.uuid !== currentListingId?.uuid)
    : allAuthorListings;

  return {
    listings,
  };
};

const mapDispatchToProps = (dispatch) => ({});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const SectionCreator = compose(connect(mapStateToProps, mapDispatchToProps))(
  SectionCreatorComponent
);

export default SectionCreator;
